export default {
  slug: 'cases',
  title: 'Cases',
  description: 'Investigation workspaces, timeline, notes, and tabs.',
  section: 'investigations',
  order: 1,
  tags: ['cases', 'timeline', 'notes'],
  body: `# Cases

A **case** is the central investigation workspace. All personas, evidence, indicators, and interactions for an operation roll up here.

## Case list

**[Investigations → Cases](/cases)** shows all cases you can access. Filter and open any row to enter the detail shell.

## Detail tabs

| Tab | Contents |
|-----|----------|
| **Overview** | Stats, description, client, lead investigator, risk, summary |
| **Relationships** | Live relationship table with pivot links |
| **Timeline** | Chronological case events |
| **Actors** | Linked threat actors |
| **Personas** | Controlled identities on the case |
| **Evidence** | Cataloged artifacts |
| **IOCs** | Indicators with clickable pivot links |
| **Interactions** | Logged communications |
| **Notes** | Analyst notes (timestamped) |
| **Reports** | Download JSON intelligence summary |
| **Audit Log** | Immutable case-scoped audit entries |

## Investigation graph

Use **Graph** in the case header to visualize case ↔ indicator ↔ search ↔ persona links. Expand into related entities without leaving the overlay.

## Case types

Common templates include scam investigation, crypto fraud, phishing collection, fake recruiter, DPRK IT worker screening, and client submission — each sets default metadata and workflow expectations.

## Best practices

- Add a timeline event when promoting indicators from intelligence searches.
- Keep **recommended actions** and **summary** updated for handoffs and client reporting.
- Use the audit tab to verify who changed what before external disclosure.
`,
};
